import { FontSizeDropdown } from 'lib/components/textEditorEmailBuilder';
import React, { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { FontSizes } from '../constants';
import htmlToDraft from 'html-to-draftjs';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { useTheme } from 'styled-components/macro';

const additionalTextEditorToolbar = {
  options: ['fontSize', 'inline', 'textAlign'],
  inline: {
    options: ['bold', 'italic', 'underline'],
    bold: {
      className:
        'toolbar-custom-icon toolbar-bold-icon medium-icon transparent-icon compact-icon',
    },
    italic: {
      className:
        'toolbar-custom-icon toolbar-italic-icon medium-icon transparent-icon compact-icon',
    },
    underline: {
      className:
        'toolbar-custom-icon toolbar-underline-icon medium-icon transparent-icon compact-icon',
    },
  },
  fontSize: {
    options: FontSizes.map(fontSize => fontSize.value),
    component: FontSizeDropdown,
  },
  textAlign: {
    textAlign: { inDropdown: false },
    inDropdown: false,
    options: ['left', 'center', 'right'],
    left: {
      className:
        'toolbar-custom-icon toolbar-align-left-icon medium-icon transparent-icon compact-icon',
    },
    center: {
      className:
        'toolbar-custom-icon toolbar-align-center-icon medium-icon transparent-icon compact-icon',
    },
    right: {
      className:
        'toolbar-custom-icon toolbar-align-right-icon medium-icon transparent-icon compact-icon',
    },
  },
};

type Props = {
  onTextEditorChange: (text: string) => void;
  initialContent?: string;
  readonly?: boolean;
};
const AdditionalTextEditor = (props: Props) => {
  const theme = useTheme();
  const { onTextEditorChange, initialContent } = props;

  let content = initialContent || '';
  if (content && content.indexOf('<p>') !== 0) {
    content = `<p>${initialContent}</p>`;
  }

  const blocksFromHTML = htmlToDraft(content);
  const initialData = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );

  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(initialData)
  );

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
    onTextEditorChange(
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
        .replace(/(<p>)/g, '')
        .replace(/(<\/p>)/g, '')
    );
  };

  return (
    <Editor
      toolbar={additionalTextEditorToolbar}
      editorStyle={{
        minHeight: '195px',
        width: '100%',
        borderRadius: '0 0 8px 8px',
        padding: 12,
        fontFamily: 'Verdana',
        boxSizing: 'border-box',
      }}
      toolbarStyle={{
        backgroundColor: theme.colors.neutral[20],
        borderRadius: '8px 8px 0 0',
        border: 'none',
        color: theme.colors.neutral[80],
        margin: 0,
        width: '100%',
        boxSizing: 'border-box',
        padding: '7px 14px',
        height: '40px',
        gap: '10px',
      }}
      wrapperStyle={{
        width: '100%',
        boxSizing: 'border-box',
        pointerEvents: props.readonly ? 'none' : 'auto',
      }}
      onEditorStateChange={onEditorStateChange}
      editorState={editorState}
      placeholder='Additional text goes here.'
    />
  );
};

export default AdditionalTextEditor;
